export const getHintImageUrl = (id) => {
  const tmpId = id.replace(/\+/g, '-');

  // Чтобы заметить картинки хинтов, нужно заменить картинки на CDN по указанному ниже адресу
  return `https://cdn-p.cian.site/images/static/vas-images/${tmpId}.png`;
};
